import makeSlice from '@web/slices/mobile/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {payMethod} = payload

            const isRegistration = payMethod.billingPayMethods.mobileEasyPay?.easyPayRegistration ?? false
            if (payMethod.billingPayMethods.mobileEasyPay) {
                state.mobileEasyPay.billing = {
                    pgCp: payMethod.billingPayMethods.mobileEasyPay.pgCp,
                    pgId: payMethod.billingPayMethods.mobileEasyPay.pgId,
                    sid: payMethod.billingPayMethods.mobileEasyPay.sid,
                    minimumAmount: payMethod.billingPayMethods.mobileEasyPay.minimumAmount,
                    maximumAmount: payMethod.billingPayMethods.mobileEasyPay.maximumAmount,
                }
                if (isRegistration) {
                    state.mobileEasyPay.isRegistration = isRegistration
                    state.mobileEasyPay.phoneNumbers = payMethod.billingPayMethods.mobileEasyPay.phoneNumber ?? ''
                }
            }
            if (payMethod.billingPayMethods.mobile) {
                state.mobileGeneralPay.billing = {
                    pgCp: payMethod.billingPayMethods.mobile.pgCp,
                    pgId: payMethod.billingPayMethods.mobile.pgId,
                    sid: payMethod.billingPayMethods.mobile.sid,
                    minimumAmount: payMethod.billingPayMethods.mobile.minimumAmount,
                    maximumAmount: payMethod.billingPayMethods.mobile.maximumAmount,
                }
            }
        })
    },
})

export default slice.reducer
